<div class="modalContainer">
  <div class="modal-header">
    <div class="modal-title">
      <img alt="success_thumb" src="../../../assets/images/rbi-compliance/success_thumb.svg" />
      <div class="mt-4">Loan Terms Withdrawn</div>
    </div>
    <div class="modal-sub-title">Suggested loan terms are withdrawn successfully</div>
  </div>

  <div class="modal-footer">
    <button (click)="decline()" type="button" mat-flat-button class="primary no-text-transform"
      [mat-dialog-close]="true" cdkFocusInitial>Back</button>
  </div>
</div>